<script lang="ts">
  import { listAdmins } from '$lib/api/users';
  import type { AdminInstructorListRecord, User } from '$lib/api/types';
  import type { TableHeaderItem } from '$lib/componentTypes';
  import UserList from '$lib/components/users/UserList.svelte';

  function buildNewUserObject(user: User): AdminInstructorListRecord {
    return {
      id: user.id,
      firstName: user.firstName,
      lastName: user.lastName,
      role: user.role,
      created: user.created,
    };
  }

  const additionalHeaders: TableHeaderItem<AdminInstructorListRecord>[] = [];
</script>

<UserList
  route="admins"
  role="admin"
  loadData={listAdmins}
  {buildNewUserObject}
  {additionalHeaders}
  headerText="Administrators"
/>
